import React from "react"
import { MaybeLink } from "../../atoms/links/MaybeLink"
import { SinglePathSVG } from "../../SVG"
import { breakpointLarge, breakpointMedium } from "css/variables/_breakpoints.scss"
import L10n from "lib/carrot-l10n"
import styled from "styled-components"

const TalkToCarrotBottomPadding = 56
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const StyledTalkToCarrotNavWrapper = styled.span`
  position: ${({ fixed }) => (fixed ? "fixed" : "")};
  bottom: ${TalkToCarrotBottomPadding}px;
  @media ${breakpointLarge} {
    width: 256px;
  }
  @media ${breakpointMedium} {
    width: 200px;
  }
`

const TalkToCarrotNav = () => (
  <MaybeLink to="/talk-to-carrot" className="talk-to-carrot-hover">
    <nav className="flex flex-column items-center db animate-all">
      <div
        className="talk-to-carrot-dim flex items-center justify-center br-pill"
        style={{
          height: "4.5rem",
          width: "4.5rem",
          boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.15)"
        }}
      >
        <SinglePathSVG icon="talkToCarrot" />
      </div>
      <div className="f6 lh-copy dib no-underline gotham black-80 mt3">{l`client.experts.heading`}</div>
    </nav>
  </MaybeLink>
)

const TalkToCarrotNavWrapper = ({ fixed }) => (
  <StyledTalkToCarrotNavWrapper fixed={fixed}>
    <TalkToCarrotNav />
  </StyledTalkToCarrotNavWrapper>
)

export { TalkToCarrotBottomPadding, TalkToCarrotNavWrapper }
